import * as React from 'react';
import PhoneInput from 'react-phone-number-input';
import CountryService from '../../shared/CountryService';

interface IProps {
    onChange: (e: any) => void;
    value: string;
    id?: string;
    name?: string;
}

const CountryCodePhoneNumberInput = (props: IProps) => {
    return (
        <div>
            <PhoneInput
                id={props.id ? props.id : undefined}
                name={props.name ? props.name : undefined}
                value={props.value}
                country={CountryService.getCountryCodeForPhoneNumberInput()}
                onChange={props.onChange}
                inputClassName="form-control"
                countries={CountryService.getAvailablePhoneCountryCodes()}
                displayInitialValueAsLocalNumber={true}
            />
        </div>
    );
};

export default CountryCodePhoneNumberInput;
